import React, { useState } from "react";
import { ControlsRow } from "../base/ControlsRow";
import { ImportantButton } from "../base/ImportantButton";
import { SecondaryButton } from "../base/SecondaryButton";
import { TextInput } from "../base/TextInput";
import { PanelTextInput } from "../base/PanelTextInput";
import { useExtendedMutation } from "mutations";
import { addPrivateSubcategory } from "api";
import "./AddSubcategoryControls.css";

const AddSubcategoryControls = ({ token, onBack, onSaved, categoryId, onLoadingChange, variant = 'default' }) => {
  const Btn = variant === 'secondary' ? SecondaryButton : ImportantButton;
  const Txt = variant === 'secondary' ? PanelTextInput : TextInput;
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const errorCallback = (error) => {
    console.log(error);
    onLoadingChange?.(false);
  };

  const addSubcategoryMutation = useExtendedMutation(
    addPrivateSubcategory,
    () => {
      setTitle('');
      setDescription('');
      onLoadingChange?.(false);
      onSaved();
    },
    errorCallback
  );

  const handleSave = () => {
    if (title.trim()) {
      onLoadingChange?.(true);
      addSubcategoryMutation.mutateOnVirtualThread({ token, title, description, categoryId });
    }
  };

  return (
    <div className="add-subcategory-controls">
      <ControlsRow horizontalOnMobile={true}>
        <Txt
          value={title}
          callbackOnChange={(e) => setTitle(e.target.value)}
          placeholder={"Subcategory title"}
          maxLength={50}
        />
        <Txt
          value={description}
          callbackOnChange={(e) => setDescription(e.target.value)}
          placeholder={"Description"}
          maxLength={100}
        />
      </ControlsRow>
      <ControlsRow horizontalOnMobile={true}>
        <Btn buttonText={"Back"} onClick={onBack} />
        <Btn buttonText={"Add"} onClick={handleSave} />
      </ControlsRow>
    </div>
  );
};

export { AddSubcategoryControls };
